
import { useEffect, useState } from 'react';
import Form from 'react-bootstrap/Form';
import Spinner from 'react-bootstrap/Spinner';
import url from '../api/url';
import { useEmpleadoStore } from '../stores/useEmpleadoStore';
import { elToast } from '../functions/Alerta';


export default function TerminosCondiciones() {

    const [aceptar, setAceptar] = useState(undefined)
    const { SERVIDOR, URL } = url()
    const objLogueado = useEmpleadoStore(state => state.objLogueado)
    const setAceptado = useEmpleadoStore(state => state.setAceptado)
    const [cargando, setCargando] = useState(false)
    const [cargandoAviso, setCargandoAviso] = useState(true)


    useEffect(() => {

        if (aceptar === undefined) {
            return
        }

        let aaa = { aceptar: aceptar ? 1 : 0, funcion: 'TerminosCondiciones', correo: objLogueado.email }

        setCargando(true)

        fetch( URL, {
            method: 'post',
            body: JSON.stringify( aaa )
        })
        .then( res => res.json() )
        .then( function (d) {
            if ( d.codigo === 1 ) {
                elToast( d.mensaje )
                setAceptado( aceptar )
            } else {
                elToast( d.mensaje, 'error' )
            }
        })
        .catch( a => {
            elToast( "Error al guardar información.\nPuedes revisar tu conexión o iniciar sesión nuevamente.", "error" )
            // alert("")
        })
        .finally( () => setCargando( false ) )

        // eslint-disable-next-line
    }, [aceptar])



    useEffect(() => {
        // traer esa cosa de si acepté
        setCargandoAviso(true)
        var fd = new FormData()
        fd.append("funcion", "traerAceptoAviso")
        fd.append("email", objLogueado.email)

        fetch( URL, {
            method: 'post',
            body: fd
        })
        .then( res => res.json() )
        .then( e => {
            setAceptado( e.aceptado )
            setAceptar( e.aceptado )
            setCargandoAviso(false)
        })
        .catch( a => {
            setCargandoAviso(false)
            elToast( 'Hay problemas al acceder al aviso de privacidad', 'error' );
        })
        // eslint-disable-next-line
    }, [])



    return (
        <div>

            <div className='text-center mb-3 mt-5'>
                <a href={ SERVIDOR + '/Aviso-Expediente-de-Personal-de-Honorarios-Profesionales-Integral.pdf' } target='_blank' rel='noreferrer' className="lead">
                    Clic aquí para ver el aviso de privacidad
                </a>
            </div>

            {
                cargandoAviso
                ? <div className='d-flex justify-content-center'>
                    <Spinner animation="border" role="status">
                        <span className="visually-hidden">Loading...</span>
                    </Spinner>
                </div>
                : <Form.Check
                    id = 'aviso'
                    type = 'checkbox'
                    className = 'd-flex justify-content-center no-select'
                    checked = { aceptar }
                    onChange = { e => setAceptar( e.target.checked ) }
                    label = '&nbsp;&nbsp;Acepto aviso de privacidad'
                />
            }

            { cargando &&
                <div className='d-flex justify-content-center'>
                    <Spinner animation="border" role="status">
                        <span className="visually-hidden">Loading...</span>
                    </Spinner>
                </div>
            }

        </div>
    )
}
